module.exports = __webpack_public_path__ + "img/logo.10c0f4f3.png";